module.exports = __webpack_public_path__ + "static/04-c9e63df44099603a35dd9960b80ae85a.png";